import { render, staticRenderFns } from "./WhitelabelShare.vue?vue&type=template&id=790b0430&scoped=true"
var script = {}
import style0 from "./WhitelabelShare.vue?vue&type=style&index=0&id=790b0430&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790b0430",
  null
  
)

export default component.exports